import type { RouteRecordRaw } from 'vue-router'
import { withAccessKeyMeta } from '@/router/access-map'
import { defaultLayout } from '@/router/base'

const routes: RouteRecordRaw[] = [
  {
    path: '/reports',
    name: 'Reports',
    component: defaultLayout,
    meta: withAccessKeyMeta('reports', {
      locale: 'common.menus.reports',
      requiresAuth: true,
      icon: 'market-analysis-report',
      hideChildrenInMenu: true,
      activeMenu: 'Reports',
      order: 1,
    }),
    children: [
      {
        path: '',
        name: 'ReportsIndex',
        component: () => import('@/views/feature/reports/index.vue'),
        meta: {
          locale: 'common.menus.reports',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Reports',
          isTopMenu: true,
        },
      },
    ],
  },
]

export default routes
